<template>
    <div>
        <container :aside="'police'">
            <div class="warp">
                <div class="head base-head">
                    <el-row>
                        <el-col :span="24" :offset="0">
                            <el-form :model="form" label-width="80px" :inline="true" size="mini">
                                <el-form-item label="辖区">
                                    <el-cascader
                                    v-model="form.classification"
                                    :options="securityArea"
                                    :props="props"
                                    collapse-tags
                                    clearable></el-cascader>
                                </el-form-item>
                                <el-form-item label="出租类型">
                                    <el-select v-model="form.rentway" value-key="" placeholder="请选择出租类型" clearable filterable>
                                        <el-option v-for="(item, key) in workinggroups"
                                            :key="key"
                                            :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="订单来源">
                                    <el-select v-model="form.source" value-key="" placeholder="请选择订单来源" clearable filterable>
                                        <el-option v-for="(item, key) in source_arr"
                                            :key="key"
                                            :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="入住时间">
                                    <el-date-picker
                                        v-model="form.checkintime"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="房东">
                                    <el-autocomplete class="header-search-input"  v-model="form.landlordinfo" popper-class="my-autocomplete" :fetch-suggestions="querySearch"  @select="handleSelect" :trigger-on-focus="false" placeholder="请输入房东姓名/手机号/身份证号" clearable>
                                        <template slot-scope="{ item }">
                                            <p class="text">{{item.name}}({{item.telephone}})</p>
                                        </template>
                                    </el-autocomplete>
                                </el-form-item>
                                <el-form-item label="房客">
                                    <el-autocomplete class="header-search-input"  v-model="form.renterinfo" popper-class="my-autocomplete" :fetch-suggestions="querySearch1"  @select="handleSelect1" :trigger-on-focus="false" placeholder="请输入房东姓名/手机号/身份证号" clearable>
                                        <template slot-scope="{ item }">
                                            <p class="text">{{item.name}}({{item.telephone}})</p>
                                        </template>
                                    </el-autocomplete>
                                </el-form-item>
                                <el-form-item label="房源">
                                    <el-input v-model="form.hkeyword" placeholder="请填写房源名称/地址"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" icon="el-icon-search" @click="onsearch">搜索</el-button>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="success" icon="el-icon-folder-opened" @click="exportinfo">导出</el-button>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                </div>

                <div class="table-box">
                    <el-table :data="tabledata" border stripe size="mini" v-loading="loading">
                        <el-table-column type="index" label="序号" width="50"></el-table-column>
                        <el-table-column prop="house_name" label="关联房源" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="landlord" label="房东" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="renterInfo.name" label="房客姓名" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="renterInfo.telephone" label="房客手机" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="renterInfo.idcard" label="房客身份证" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="" label="入住人数" show-overflow-tooltip>
                            <span slot-scope="scope">{{(scope.row.maxRenterNumber?scope.row.maxRenterNumber:'未设置')+'/：'+scope.row.renterNun+'人'}}</span>
                        </el-table-column>
                        <el-table-column prop="" label="入住时间" show-overflow-tooltip>
                            <span slot-scope="scope">{{scope.row.start+'至'+scope.row.end}}</span>
                        </el-table-column>
                        <el-table-column prop="faceIdRequired" label="人脸识别" show-overflow-tooltip>
                            <span slot-scope="scope">{{scope.row.faceIdRequired?'已使用':'未使用'}}</span>
                        </el-table-column>
                        <!-- <el-table-column prop="deposit" label="押金" show-overflow-tooltip></el-table-column> -->
                        <el-table-column prop="source" label="订单来源" show-overflow-tooltip>
                            <span slot-scope="scope">{{scope.row.source||'微管家'}}</span>
                        </el-table-column>
                        <el-table-column label="操作" fixed="right" width="240">
                            <template slot-scope="s">
                                <el-button-group>
                                    <el-button type="primary" size="mini" icon="el-icon-s-custom" @click="statedetail(s.row)">房态详情</el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="out-table-box">
                    <el-table id="out-table" :data="outtabledata" border stripe size="mini" v-loading="loading">
                        <el-table-column type="index" label="序号" width="50"></el-table-column>
                        <el-table-column prop="house_name" label="关联房源" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="landlord" label="房东" show-overflow-tooltip></el-table-column>
                        <!-- <el-table-column prop="renter" label="房客" show-overflow-tooltip>
                            <template slot-scope="s">
                                <p class="text" v-if="s.row.renter">{{s.row.renter}}({{s.row.renterInfo?s.row.renterInfo.idcard:''}})</p>
                                <p class="text" v-for="(item, index) in s.row.otherRenters" :key="index">{{item.name}}({{item.telephone}})({{item.idcard}})</p>
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="renterInfo.name" label="房客姓名" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="renterInfo.telephone" label="房客手机" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="renterInfo.idcard" label="房客身份证" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="" label="入住人数" show-overflow-tooltip>
                            <span slot-scope="scope">{{(scope.row.maxRenterNumber?scope.row.maxRenterNumber:'未设置')+'/：'+scope.row.renterNun+'人'}}</span>
                        </el-table-column>
                        <el-table-column prop="" label="入住时间" show-overflow-tooltip>
                            <span slot-scope="scope">{{scope.row.start+'至'+scope.row.end}}</span>
                        </el-table-column>
                        <el-table-column prop="faceIdRequired" label="人脸识别" show-overflow-tooltip>
                            <span slot-scope="scope">{{scope.row.faceIdRequired?'已使用':'未使用'}}</span>
                        </el-table-column>
                        <!-- <el-table-column prop="deposit" label="押金" show-overflow-tooltip></el-table-column> -->
                        <el-table-column prop="source" label="订单来源" show-overflow-tooltip>
                            <span slot-scope="scope">{{scope.row.source||'微管家'}}</span>
                        </el-table-column>
                    </el-table>
                </div>

                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    small
                    :total="total" background>
                </el-pagination>
                <router-view></router-view>
            </div>
        </container>
    </div>
</template>

<script>
import FileSaver from 'file-saver';
import XLSX from "xlsx";
import Container from '../../../components/container.vue'
export default {
    components: {
        Container,
    },
    data() {
        return {
            form: {
                police: '',
                rentway: '',
                hkeyword: '',
                landlorduid: '',
                landlordinfo: '',
                renterinfo: '',
                renteruid: '',
                source: '',
                checkintime: [],
                classification: [],
            },
            securityArea: [],
            props: { multiple: true },
            workinggroups: ['长租', '网约房', '板房', '合租', '公租'],
            source_arr: ['警察添加','微管家', '续住', '线下', 'airbnb', '蚂蚁', '小猪', '途家', '美团', 'booking', '携程', '去哪儿', '艺龙', '榛果', '飞猪', '云掌柜', '其它'],
            loading: false,
            tabledata: [],
            pagesize: 15,
            pageNo: 0,
            total: 0,
            outtabledata: [],
        }
    },
    mounted () {
        this.gettabledata();
        this.getSecurityArea();
    },
    methods: {
        exportinfo() {
            if (this.loading) return;
            this.loading = true;
            var that = this;
            var rentway = this.form.rentway;
            var params = {
                rentway: rentway,
                hkeyword: this.form.hkeyword,
                landlorduid: this.form.landlorduid,
                renteruid: this.form.renteruid,
                checkintime: JSON.stringify(this.form.checkintime),
                classification: JSON.stringify(this.form.classification),
                pageNo: this.pageNo,
                pagesize: 999999999,
                source: this.form.source,
            }
            this.$api.gethousestateonsearch(params)
                .then(data=>{
                    this.loading = false;
                    let {list} = data;
                    this.outtabledata = list;
                    this.$nextTick(function(){
                        that.exportExcel();
                    })
                })
        },
        exportExcel () {
            var xlsxParam = { raw: true }; // 导出的内容只做解析，不进行格式转换(添加此行代码表格中的百分比就不会再导出的时候被转换成小数点)
            let wb = XLSX.utils.table_to_book(
                document.querySelector("#out-table"),
                xlsxParam
            );
            let wbout = XLSX.write(wb, {
                bookType: "xlsx",
                bookSST: true,
                type: "array"
            });
            // 获取当前的时间戳，用来当文件名
            let time = new Date().getTime();
            try {
                FileSaver.saveAs(
                new Blob([wbout], { type: "application/octet-stream" }),
                `${time}.xlsx`
                ); //${time}是自己导出文件时的命名，随意
            } catch (e) {
                // if (typeof console !== "undefined") console.log(e, wbout);
            }
            return wbout;
        },
        getSecurityArea() {
            this.$api.getSecurityArea({})
                .then(data=>{

                    let {securityArea} = data;
                    this.securityArea = securityArea;
                })
        },
        querySearch1(queryString, cb) {
            var params = {
                keyword: queryString
            }
            this.$api.getrenterlistvskeyword(params)
                .then(data=>{
                    let {list} = data;
                    cb(list);
                })
        },
        handleSelect1(item) {
            this.form.renterinfo = item.name + '(' + item.telephone + ')';
            this.form.renteruid = item._id;
        },
        querySearch(queryString, cb) {
            var params = {
                searchParameter: {
                    value: queryString,
                    type: 'landlord',
                }
            }
            this.$api.getHouseListBySearch(params)
                .then(data=>{
                    let {landlordList} = data;
                    cb(landlordList);
                })
        },
        handleSelect(item) {
            this.form.landlordinfo = item.name + '(' + item.telephone + ')';
            this.form.landlorduid = item._id;
        },
        onsearch() {
            this.pageNo = 0;
            this.gettabledata();
        },
        gettabledata() {
            var rentway = this.form.rentway;
            var params = {
                rentway: rentway,
                hkeyword: this.form.hkeyword,
                landlorduid: this.form.landlorduid,
                renteruid: this.form.renteruid,
                checkintime: JSON.stringify(this.form.checkintime),
                classification: JSON.stringify(this.form.classification),
                pageNo: this.pageNo,
                pagesize: this.pagesize,
                source: this.form.source,
            }
            this.$api.gethousestateonsearch(params)
                .then(data=>{
                    let {list, total} = data;
                    this.tabledata = list;
                    this.total = total;
                })
        },
        statedetail(item) {
            var hsid = item._id['$oid']
            this.$router.push({path: '/police/housestate/detail', query:{hsid}})
        },
        currentChange(page) {
            this.pageNo = page-1;
            this.gettabledata();
        },
    },
}
</script>

<style lang="scss" scoped>
.search-input{
    /deep/.el-input__inner{
        border: none;
    }
}

.out-table-box{
    position: absolute;
    bottom: -99999999px;
}
</style>